import { render } from "./call-our.vue?vue&type=template&id=3a0aa116&scoped=true"
import script from "./call-our.vue?vue&type=script&lang=js"
export * from "./call-our.vue?vue&type=script&lang=js"

import "./call-our.vue?vue&type=style&index=0&id=3a0aa116&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0aa116"]])

export default __exports__